<template>
  <div class="carNumInput">
    <div class="content-car-number">
      <div class="car-content-title">
        <span>车牌号</span>
        <label class="ze-checkbox">
          <input type="checkbox" v-model="checkbox" @change="carTypeChange" />
          <span class="ze-checkbox-icon" style="width: 20px;height: 20px;color: rgb(76, 216, 100);">
            <i style="width: 6px;height: 12px;"></i>
          </span>
          <span class="ze-checkbox-text">新能源</span>
        </label>
      </div>
      <div class="content-section">
        <div class="content-section-flex flex-card">
          <div class="content-section-flex flex-card-border">
            <div
              id="font"
              class="flex-btn"
              @click="btnClickYue"
              v-bind:class="{isClick: isYue }"
            >{{areaName}}</div>
            <span class="blank-border blank-border-first"></span>
            <div
              id="letter"
              class="flex-btn"
              @click="btnClickA"
              v-bind:class="{isClick: isA}"
            >{{areaLetter}}</div>

            <div class="flex-mid">
              <span></span>
            </div>
            <div class="flex-btns">
              <div
                id="numOne"
                @click="btnClickNum('one')"
                v-bind:class="{isNumClick: isNumOne }"
              >{{numOne}}</div>
              <span class="blank-border"></span>
              <div
                id="numTwo"
                @click="btnClickNum('two')"
                v-bind:class="{isNumClick: isNumTwo }"
              >{{numTwo}}</div>
              <span class="blank-border"></span>
              <div
                id="numThree"
                @click="btnClickNum('three')"
                v-bind:class="{isNumClick: isNumThree }"
              >{{numThree}}</div>
              <span class="blank-border"></span>
              <div
                id="numFour"
                @click="btnClickNum('four')"
                v-bind:class="{isNumClick: isNumFour }"
              >{{numFour}}</div>
              <span class="blank-border"></span>
              <div
                id="numFive"
                @click="btnClickNum('five')"
                v-bind:class="{isNumClick: isNumFive }"
              >{{numFive}}</div>
              <span class="blank-border" v-if="checkbox"></span>
              <div
                v-if="checkbox"
                id="numSix"
                @click="btnClickNum('six')"
                v-bind:class="{isNumClick: isNumSix }"
              >{{numSix}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ----------------------------------------------------------------------------------------------------------------- -->
    <!-- 车牌输入专用键盘 -->
    <div class="keyboard" v-if="keyboardShow" :class="{animationDown:isDown,animationUp:isUp}">
      <button class="btn-complete" @click="completeClick">
        <span>完成</span>
      </button>
      <div v-if="keyboard == 'txt'">
        <div class="keyboard-row" v-for="(item,rows) in carTxt" v-bind:key="rows">
          <div
            class="keyboard-row-item"
            v-for="(i,index) in item.name"
            v-bind:key="index"
            @click="btnWordClick(rows,index,i)"
          >{{i}}</div>
        </div>
        <div class="keyboard-row">
          <!-- <div class="keyboard-row-items"> -->
          <div class="keyboard-row-item " @click="btnBottomClick('新')">新</div>
          <div class="keyboard-row-item " @click="btnBottomClick('临')">临</div>
          <div v-for="(j,index) in noneBottomtxt" v-bind:key="index" class="none-botton">{{j}}</div>
          <div class="keyboard-row-item clear" @click="clearClick">
            <van-icon size="30" style="margin-top:5px" name="./static/img/key-clear1.png"/>
          </div>
        </div>
      </div>
      <div v-if="keyboard == 'num'">
        <div class="keyboard-row" v-for="(item,rows) in carNum" v-bind:key="rows">
          <div
            :disabled="!isSelectl?isDisable && i<10 :isDisable&& rows!=0 "
            class="keyboard-row-item"
            v-for="(i,index) in item.name"
            v-bind:key="index"
            @click="btnWordClick(rows,index,i)"
          >{{i}}</div>
        </div>
        <div class="keyboard-row">
          <!-- <div class="keyboard-row-bottom"> -->
          <div
            :disabled="isSelectl"
            v-for="item in carNumBottom"
            v-bind:key="item"
            class="keyboard-row-item bottom"
            @click="btnBottomNumClick(item)"
          >{{item}}</div>
          <div v-for="(j,index) in noneBottom" v-bind:key="index" class="none-botton">{{j}}</div>
          <div class="keyboard-row-item clear" @click="clearClick">
            <van-icon size="30" name="./static/img/key-clear1.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "carNumInput",
  data() {
    return {
      title: "",
      active: "2",
      finalCarNum:"",
      toastTxt: "",
      isToastShow: false,
      isStr: "20px",
      isEnd: "300px",
      ispickerDateShow: "-400px",
      dateTitle: "开始",
      beginTimeVal: "",
      overTimeVal: "",
      isFeeHourClick: true,
      checkbox: false,
      isDown: false,
      isUp: false,
      selected: null,
      isSelectx: false,
      isSelectl: false,
      key:"1",
      areaName: "",
      areaLetter: "",
      numOne: "",
      numTwo: "",
      numThree: "",
      numFour: "",
      numFive: "",
      numSix: "",
      isYue: false,
      keyboardShow: false,
      keyboard: false,
      isA: false,
      isNumOne: false,
      isNumTwo: false,
      isNumThree: false,
      isNumFour: false,
      isNumFive: false,
      isNumSix: false,
      isDisable: false,
      carTxt: [
        { name: ["渝", "京", "冀", "沪", "津", "晋", "蒙", "辽", "吉", "黑"] },
        { name: ["川", "浙", "皖", "闽", "赣", "鲁", "豫", "鄂", "湘", "桂"] },
        { name: ["琼", "粤", "苏", "贵", "云", "藏", "陕", "甘", "青", "宁"] }
      ],
      carNumBottom: ["W", "X", "Y", "Z"],
      noneBottom: ["", "", "", "",""],
      noneBottomtxt: ["", "", "", "", "", "",""],
      carNum: [
        { name: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"] },
        { name: ["A", "B", "C", "D", "E", "F", "G", "H", "J", "K"] },
        { name: ["L", "M", "N", "P", "Q", "R", "S", "T", "U", "V"] }
      ],
      addedCarNum: ""
    };
  },

  watch: {
    checkbox: function(val, oldval) {
      //监听是否为新能源
      this.isNumOne = false;
      this.isNumTwo = false;
      this.isNumThree = false;
      this.isNumFour = false;
      this.isNumFive = false;
      this.isNumSix = false;
      const vm = this;
      if (!val) {
        // 切换到普通车牌
        if (vm.numFour) {
          vm.isNumFive = true;
          vm.key = 7;
        }
      } else {
        // 切换到新能源车牌
        if (vm.numFive) {
          vm.isNumSix = true;
          vm.key = 8;
        }
      }
    },
    numFive: function(val) {
      //监听是否为普通车牌最后一位
      if (!this.checkbox && val) {
        this.isUp = false;
        this.isDown = true;
        this.keyboardShow = false;
        this.isNumFive = false;
        this.getCarNum();
      }
    },
    numSix: function(val) {
      //监听是否为新能源车牌最后一位
      if (this.checkbox && val) {
        this.isUp = false;
        this.isDown = true;
        this.keyboardShow = false;
        this.isNumSix = false;
        this.getCarNum();
      }
    }
  },

  methods: {
    onClickLeft() {
      console.log("返回");
      this.$router.push("/menu");
    },
    queryBycarNum() {
      this.$router.push("/oweFeeOrderList");
    },
    parkingRecordList() {
      {
        this.$router.push("/parkingRecordList");
      }
    },
    // 车牌类型切换
    carTypeChange(val) {
      this.isNumOne = false;
      this.isNumTwo = false;
      this.isNumThree = false;
      this.isNumFour = false;
      this.isNumFive = false;
      this.isNumSix = false;
      if (!val) {
        // 切换到普通车牌
        if (this.numFour) {
          this.isNumFive = true;
          this.key = 7;
        }
      } else {
        // 切换到新能源车牌
        if (this.numFive) {
          this.isNumSix = true;
          this.key = 8;
        }
      }
    }, // 车牌号第一位输入框选择
    btnClickYue() {
      this.isYue = true;
      this.isA = false;
      this.isUp = true;
      this.isNumOne = false;
      this.isNumTwo = false;
      this.isNumThree = false;
      this.isNumFour = false;
      this.isNumFive = false;
      this.isNumSix = false;
      this.keyboardShow = true;
      this.keyboard = "txt";
      this.key = 1;
    }, // 键盘选择显示
    btnWordClick(rows, index, i) {
      this.selected = i;
      if (this.key === 1) {
        if (this.areaName === "临") {
          this.areaLetter = "";
          this.numOne = "";
          this.numTwo = "";
          this.numThree = "";
          this.numFour = "";
          this.numFive = "";
          this.numSix = "";
        }
        this.areaName = i;
        this.isSelectl = false;
        document.getElementById("letter").click();
      } else if (this.key === 2) {
        this.areaLetter = i;
        document.getElementById("numOne").click();
      } else if (this.key === 3) {
        this.numOne = i;
        document.getElementById("numTwo").click();
      } else if (this.key === 4) {
        this.numTwo = i;
        document.getElementById("numThree").click();
      } else if (this.key === 5) {
        this.numThree = i;
        document.getElementById("numFour").click();
      } else if (this.key === 6) {
        this.numFour = i;
        document.getElementById("numFive").click();
      } else if (this.key === 7) {
        this.numFive = i;
        if (this.checkbox) {
          document.getElementById("numSix").click();
        }
      } else if (this.key === 8) {
        this.numSix = i;
      }
      if (this.key === 7 || this.key === 8) {
        this.carNumBottom = ["W", "X", "Y", "Z", "港", "澳", "学"];
        this.noneBottom = [""];
      } else if (
        this.key === 3 ||
        this.key === 4 ||
        this.key === 5 ||
        this.key === 6
      ) {
        this.carNumBottom = ["W", "X", "Y", "Z"];
        this.noneBottom = ["", "", "", ""];
      }
      this.getCarNumParent();
    }, // 车牌第一位选择‘临’,’新‘后的键盘显示
    btnBottomClick(val) {
      if (val === "新") {
        if (this.areaName === "临") {
          this.areaLetter = "";
          this.numOne = "";
          this.numTwo = "";
          this.numThree = "";
          this.numFour = "";
          this.numFive = "";
          this.numSix = "";
        }
        this.areaName = "新";
        this.isSelectx = true;
        this.isSelectl = false;
        document.getElementById("letter").click();
      } else if (val === "临") {
        this.areaName = "临";
        this.isSelectl = true;
        this.isSelectx = false;
        this.isDisable = true;
        this.areaLetter = "";
        this.numOne = "";
        this.numTwo = "";
        this.numThree = "";
        this.numFour = "";
        this.numFive = "";
        this.numSix = "";
        document.getElementById("letter").click("isLin");
      }
      this.getCarNumParent();
    }, // 键盘最后一行字母点击事件
    btnBottomNumClick(i) {
      this.selected = i;
      if (this.key === 2) {
        this.areaLetter = i;
        document.getElementById("numOne").click();
      } else if (this.key === 3) {
        this.numOne = i;
        document.getElementById("numTwo").click();
      } else if (this.key === 4) {
        this.numTwo = i;
        document.getElementById("numThree").click();
      } else if (this.key === 5) {
        this.numThree = i;
        document.getElementById("numFour").click();
      } else if (this.key === 6) {
        this.numFour = i;
        document.getElementById("numFive").click();
      } else if (this.key === 7) {
        this.numFive = i;
        if (this.checkbox) {
          document.getElementById("numSix").click();
        }
      } else if (this.key === 8) {
        this.numSix = i;
      }
    }, // 车牌号第二位输入框选择
    btnClickA() {
      this.isDisable = true;
      this.isA = true;
      this.isYue = false;
      this.isUp = true;
      this.isNumOne = false;
      this.isNumTwo = false;
      this.isNumThree = false;
      this.isNumFour = false;
      this.isNumFive = false;
      this.isNumSix = false;
      this.keyboardShow = true;
      this.keyboard = "num";
      this.key = 2;
    }, // 车牌号后五位或六位输入框选择
    btnClickNum(name) {
      if (this.isSelectl) {
        this.isDisable = true;
      } else {
        this.isDisable = false;
      }
      this.keyboard = "num";
      this.keyboardShow = true;
      this.isYue = false;
      this.isA = false;
      this.isNumOne = false;
      this.isNumTwo = false;
      this.isNumThree = false;
      this.isNumFour = false;
      this.isNumFive = false;
      this.isNumSix = false;
      this.isUp = true;
      if (name === "one") {
        this.isNumOne = true;
        this.key = 3;
      } else if (name === "two") {
        this.isNumTwo = true;
        this.key = 4;
      } else if (name === "three") {
        this.isNumThree = true;
        this.key = 5;
      } else if (name === "four") {
        this.isNumFour = true;
        this.key = 6;
      } else if (name === "five") {
        this.isNumFive = true;
        this.key = 7;
      } else if (name === "six") {
        this.isNumSix = true;
        this.key = 8;
      }
      if (name === "five" || name === "six") {
        this.carNumBottom = ["W", "X", "Y", "Z", "港", "澳", "学"];
        this.noneBottom = ["",""];
      } else {
        this.carNumBottom = ["W", "X", "Y", "Z"];
        this.noneBottom = ["", "", "", "",""];
      }
    }, // 键盘点击‘完成’
    completeClick() {
      this.isYue = false;
      this.isA = false;
      this.isNumOne = false;
      this.isNumTwo = false;
      this.isNumThree = false;
      this.isNumFour = false;
      this.isNumFive = false;
      this.isNumSix = false;
      this.isUp = false;
      this.isDown = true;
      this.keyboardShow = false;
      this.getCarNum();
    }, // 键盘点击‘删除图标’
    clearClick() {
      if (this.key == 1) {
        this.areaName = "";
      } else if (this.key == 2) {
        document.getElementById("font").click();
        this.areaLetter = "";
      } else if (this.key == 3) {
        document.getElementById("letter").click();
        this.numOne = "";
      } else if (this.key == 4) {
        document.getElementById("numOne").click();
        this.numTwo = "";
      } else if (this.key == 5) {
        document.getElementById("numTwo").click();
        this.numThree = "";
      } else if (this.key == 6) {
        document.getElementById("numThree").click();
        this.numFour = "";
      } else if (this.key == 7) {
        document.getElementById("numFour").click();
        this.numFive = "";
      } else if (this.key == 8) {
        document.getElementById("numFive").click();
        this.numSix = "";
      }
    },
    //获取最终输入的车牌号
    getCarNum(){
        if(!this.checkbox){
          this.finalCarNum=this.areaName +
          this.areaLetter +
          this.numOne +
          this.numTwo +
          this.numThree +
          this.numFour +
          this.numFive;
          if(this.finalCarNum.length<7){
              this.$toast("请输入完整车牌");
          }
        }
        else{
            this.finalCarNum =
          this.areaName +
          this.areaLetter +
          this.numOne +
          this.numTwo +
          this.numThree +
          this.numFour +
          this.numFive +
          this.numSix;
          if(this.finalCarNum.length<8){
              this.$toast("请输入完整车牌");
          }
        }
       console.log(this.finalCarNum);
       this.$emit("getcarNum",this.finalCarNum);
    //车牌号传出
    },
    getCarNumParent(){
        if(!this.checkbox){
          this.finalCarNum=this.areaName +
          this.areaLetter +
          this.numOne +
          this.numTwo +
          this.numThree +
          this.numFour +
          this.numFive;
          if(this.finalCarNum.length==7){
              this.$emit("getcarNumParent",this.finalCarNum);
          }else{
            this.$emit("getcarNumParent","");
          }
        }
        else{
            this.finalCarNum =
          this.areaName +
          this.areaLetter +
          this.numOne +
          this.numTwo +
          this.numThree +
          this.numFour +
          this.numFive +
          this.numSix;
          if(this.finalCarNum.length==8){
              this.$emit("getcarNumParent",this.finalCarNum);
          }else{
            this.$emit("getcarNumParent","");
          }
        }
    //车牌号传出
    },
    addCar() {
      var myApp = new Framework7();
      var num;
      var str = document.getElementById("picker-str-date").value;
      var end = document.getElementById("picker-end-date").value;
      var bt = new Date(str.replace(/\-/g, "/"));
      var et = new Date(end.replace(/\-/g, "/"));
      if (!this.checkbox) {
        num =
          this.areaName +
          this.areaLetter +
          this.numOne +
          this.numTwo +
          this.numThree +
          this.numFour +
          this.numFive;
      } else if (this.checkbox) {
        num =
          this.areaName +
          this.areaLetter +
          this.numOne +
          this.numTwo +
          this.numThree +
          this.numFour +
          this.numFive +
          this.numSix;
      }
      if (num === "") {
        this.toastMessage("请输入车牌", 1000);
      } else if (
        !this.checkbox &&
        (this.areaName === "" ||
          this.areaLetter === "" ||
          this.numOne === "" ||
          this.numTwo === "" ||
          this.numThree === "" ||
          this.numFour === "" ||
          this.numFive === "")
      ) {
        this.toastMessage("请输入完整车牌", 1000);
      } else if (
        this.checkbox &&
        (this.areaName === "" ||
          this.areaLetter === "" ||
          this.numOne === "" ||
          this.numTwo === "" ||
          this.numThree === "" ||
          this.numFour === "" ||
          this.numFive === "" ||
          this.numSix === "")
      ) {
        this.toastMessage("请输入完整车牌", 1000);
      } else if (str !== "" && end !== "" && bt >= et) {
        this.toastMessage("开始时间必须早于结束时间", 1000);
      } else {

      }
    }
  },
  created() {
    this.areaName = "渝";
  }
};
</script>

<style scoped>
.carNumInput {
  min-height: 80px;
  width: 100%;
  max-width: 100%;
  /* background-color: #e8e9eb; */
  float: left;
}
.nav_bar {
  width: 100%;
  height: 46px;
  float: left;
}
.car_num_holder {
  height: 60px;
  width: 100%;
  float: left;
}
.bt_qurey {
  width: 90%;
  margin-left: 5%;
  bottom: 20px;
  position: fixed;
  display: block;
}


/* 车牌输入框 */
.car-content-title label{
  color: black;
  font-weight: 400;
  float: right;
  margin-right: 40px;
  color: green;
  font-size: 15px;
}
.car-content-title>span{
  margin-left: 40px;
  color: #f47b20;
  font-size: 15px;
}
.content-section-flex{
  display: flex;
  height: 50px;
  margin: 5px auto;
}
.flex-btn{
  width:40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #FFF;
  font-size: 20px;
  color: #000;
  border-radius: 5px;
  margin-left: 2px;
  border: 1px solid #f47b20;
}
.flex-btns{
  text-align: center;
  width: fit-content;
  position: relative;
  height: 40px;
}
.flex-btns>div {
width: 40px;
height: 40px;
line-height: 40px;
font-size: 20px;
color: #000;
background-color: #FFF;
/* border-radius: 50%; */
border: 1px solid #f47b20;
border-radius: 5px;
float: left;
margin-left: 2px;
z-index: 2;
position: relative;
}
.flex-mid{
  margin: 0,0.1rem;
}
.isClick{
border: 1px solid red; /*no*/
z-index: 50;
border-radius: 5px;

}
.isNumClick{
border: 1px solid red!important;; /*no*/
z-index: 50;
border-radius: 5px;
}
/* .flex-card-border {
border: 1px solid #f47b20;
border-radius: 8px;
}
/* 车牌输入专用键盘 */
.keyboard{
width: 100%;
height: 230px;
position: fixed;
background: #bbb;
z-index: 10;
bottom: 1px;
}
.btn-complete{
height: 32px;
text-align: right;
color: #ffc200;
font-size: 14px;
width: 100%;
background: #e8e9eb;
border: none;
}
.btn-complete span {
  margin-right: 4px;
}
.keyboard-row{
margin-top: 6px;
display: flex;
justify-content: space-between;
padding: 0 8px;
color: #333;
}
.keyboard-row-item{
width: 35px;
height: 35px;
line-height: 35px;
background: #fff;
font-size: 14px;
text-align: center;
border: 1px solid #ccc; /*no*/
border-radius: 4px;
color: #333;

}
.none-botton{
width: 35px;
height: 35px;
border: 1px solid #ccc;
visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/template/carNumInput.vue